// extracted by mini-css-extract-plugin
export default {"icon":"CmsIcon-module__icon-GmWy9k","primary":"CmsIcon-module__primary-ckWOjG","secondary":"CmsIcon-module__secondary-S8S3Zz","contrast":"CmsIcon-module__contrast-e1THtT"};